import React from 'react';
import Icon from '../../../components/AppIcon';


const AuthenticationCard = ({ children }) => {
  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-card rounded-2xl shadow-lg border border-border p-8 sm:p-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
            <Icon name="Database" size={32} color="var(--color-primary)" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
            S3 File Manager
          </h1>
          <p className="text-sm text-muted-foreground text-center">
            Secure cloud storage management for your business
          </p>
        </div>

        <div className="space-y-4">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-foreground mb-2">
              Welcome Back
            </h2>
            <p className="text-sm text-muted-foreground">
              Sign in to access your S3 buckets and manage your files
            </p>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthenticationCard;